export default __webpack_public_path__ + "static/media/left-top-vinho.e5c0ad4e.png";